import React from "react";
import i18n from "@microdoing/shared/i18n";
import { Box, MainText } from "app/components/common";
import OnboardingWebInfo from "app/components/common/Onboarding/OnboardingWebInfo";
import normalize from "app/utils/normalize";
import InputCode from "./InputCode";
import { useSelector } from "react-redux";
import {
  getSignupAccessCode,
  getSignupError,
  getSignupRequesting,
} from "@microdoing/shared/services/signup/selectors";
import theme from "app/Theme/Theme";
import { isWebDesktop } from "@microdoing/shared/utils/deviceDetectors";
import OnboardingWebBody from "app/components/common/Onboarding/OnboardingWebBody";

const CodeImage = require("../../../assets/images/magic-code.png");

interface IAppProps {
  onChangeAccessCode: (accessCode: string) => void;
  goNext: () => void;
  goToLogin: () => void;
}

const WebSignup = ({ onChangeAccessCode, goNext, goToLogin }: IAppProps) => {
  const accessCode = useSelector(getSignupAccessCode);
  const error = useSelector(getSignupError);
  const requesting = useSelector(getSignupRequesting);

  return (
    <Box flex={1} justifyContent="center" backgroundColor="neutral.white">
      <Box variant="webOnboarding" flexDirection="row">
        <OnboardingWebInfo image={CodeImage} />
        <OnboardingWebBody
          title={i18n.t("join-campaign")}
          subTitle={i18n.t("enter-magic-code")}
          body={
            <Box marginTop="xm">
              <InputCode
                style={styles.input}
                value={accessCode}
                setValue={onChangeAccessCode}
              />
              {error === "Invalid code" && (
                <MainText
                  variant="l2-medium"
                  color="system.red.950"
                  marginRight="m"
                  marginTop="xl"
                  textAlign="left"
                >
                  {i18n.t("signup-companyNotFound")}
                </MainText>
              )}
            </Box>
          }
          testIDButton="signup-magic-code-submit"
          textButton={i18n.t("validate")}
          onPressButton={goNext}
          isButtonDisable={!accessCode || accessCode.length < 8}
          isButtonLoading={requesting}
          firstTextRedirection={i18n.t("got-an-account")}
          secondTextRedirection={i18n.t("i-login")}
          onPressRedirection={goToLogin}
        />
      </Box>
    </Box>
  );
};

const styles = {
  input: {
    height: normalize(50),
    borderRadius: isWebDesktop ? normalize(8) : normalize(4),
    marginBottom: theme.spacing.s,
  },
};

export default WebSignup;
